import {
    apiRequest,
    jenisDiklatDetail, 
    jenisDiklatUpdate,
    jenisDiklatBknList,
} from "../../../../../services/adapters/kepegawaian/jenisDiklatService"

class IndexRepository {
    fetchDiklatBkn = async (query) => {
        return await apiRequest("get", jenisDiklatBknList, {
            params: query
        })
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", jenisDiklatDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", jenisDiklatUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository